import { c as _c } from "react/compiler-runtime";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import InfoCard from "../InfoCard";
import StatusIcon from "../StatusIcon";
const Disqualified = () => {
  const $ = _c(25);
  const {
    t
  } = useBookingTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <StatusIcon color="warning" icon="Info" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("disqualified.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h2 className="text-h2 font-semibold">{t1}</h2>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("disqualified.description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="text-body-2">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("disqualified.recommendationTitle");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("disqualified.recommendationDescription");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <InfoCard title={t5} description={t6} />;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("disqualified.closing");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <p className="text-body-2">{t8}</p>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t4 || $[22] !== t7 || $[23] !== t9) {
    t10 = <div className="flex flex-col gap-3s items-center text-center w-[600px] max-w-full">{t0}{t2}{t4}{t7}{t9}</div>;
    $[20] = t2;
    $[21] = t4;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default Disqualified;